module.exports = __webpack_public_path__ + "img/1481494282.654b682e.jpg";